import { Influencer, Post } from "types/influencer"
import InfluencerCardHeader from "./InfluencerCardHeader"
import React from "react"
import { formatNumber } from "utils/helpers"
import InfluencerContent from "./InfluencerContent"
import { AppDispatch } from "store"
import { useDispatch } from "react-redux"
import { showInfluencerPostModal } from "slices/ui/reducer"
import { ACCOUNT_NOT_FOUND_MSG } from "constants/global"
import { SocialPost } from "types/campaign/collaborations"

interface InfluencerProfileProps {
    influencer: Influencer,
}
const InfluencerProfile: React.FC<InfluencerProfileProps> = ({ influencer }) => {

    const dispatch: AppDispatch = useDispatch();

    const handleMediaClick = (post: SocialPost) => {
        dispatch(showInfluencerPostModal({ postId: post.uuid, influencer }))
    }

    return (
        <React.Fragment>
            <div className="border-bottom-1">
                <div className="p-4">
                    <InfluencerCardHeader borderBottom={false} influencer={influencer} />
                </div>
            </div>
            {
                influencer?.social_account ? (
                    <InfluencerContent onMediaClick={handleMediaClick} socialAccountId={influencer.social_account.uuid} socialAccount={influencer.social_account} influencerId={influencer.uuid} />
                ) : (
                    <div className="account-not-available-card influncer-profile-content">
                        <span className="w-75">{ACCOUNT_NOT_FOUND_MSG}</span>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default InfluencerProfile